import { render, staticRenderFns } from "./VariantsList.vue?vue&type=template&id=a74310c4&scoped=true"
import script from "./VariantsList.vue?vue&type=script&lang=js"
export * from "./VariantsList.vue?vue&type=script&lang=js"
import style0 from "./VariantsList.vue?vue&type=style&index=0&id=a74310c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74310c4",
  null
  
)

export default component.exports